import { c as _c } from "react/compiler-runtime";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { useId } from "react";
interface DateAccordionProps {
  readonly title: React.ReactNode;
  readonly titleActions?: React.ReactNode | undefined;
  readonly isExpanded: boolean;
  readonly onToggle: () => void;
  readonly collapsedContent?: React.ReactNode | undefined;
  readonly children: React.ReactNode;
  readonly showChevron?: boolean | undefined;
}
export default function DateAccordion(t0) {
  const $ = _c(41);
  const {
    title,
    titleActions,
    isExpanded,
    onToggle,
    collapsedContent,
    children,
    showChevron: t1
  } = t0;
  const showChevron = t1 === undefined ? true : t1;
  const contentId = useId();
  const titleId = `${contentId}-title`;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 10
    };
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      duration: 0.4
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isExpanded) {
    t5 = isExpanded ? {
      rotate: 0
    } : {
      rotate: 180
    };
    $[3] = isExpanded;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.3
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `tw-size-4 ${showChevron ? "tw-text-primary-400" : "tw-text-iron-700"} tw-transition-all tw-duration-200`;
  let t8;
  if ($[6] !== t7) {
    t8 = <FontAwesomeIcon icon={faChevronDown} className={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5 || $[9] !== t8) {
    t9 = <m.span animate={t5} transition={t6} className="tw-shrink-0 tw-rounded-full tw-p-1.5 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-700/30">{t8}</m.span>;
    $[8] = t5;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== title || $[12] !== titleId) {
    t10 = <span id={titleId} className="tw-min-w-0 tw-text-base tw-font-semibold tw-text-iron-300">{title}</span>;
    $[11] = title;
    $[12] = titleId;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== contentId || $[15] !== isExpanded || $[16] !== onToggle || $[17] !== t10 || $[18] !== t9 || $[19] !== titleId) {
    t11 = <button type="button" onClick={onToggle} aria-expanded={isExpanded} aria-controls={contentId} aria-labelledby={titleId} className="tw-flex tw-min-w-0 tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 tw-text-left focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-400">{t9}{t10}</button>;
    $[14] = contentId;
    $[15] = isExpanded;
    $[16] = onToggle;
    $[17] = t10;
    $[18] = t9;
    $[19] = titleId;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== titleActions) {
    t12 = titleActions !== undefined && titleActions !== null && <div className="tw-flex tw-shrink-0 tw-items-center tw-gap-x-2">{titleActions}</div>;
    $[21] = titleActions;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-2">{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== collapsedContent || $[27] !== isExpanded) {
    t14 = !isExpanded && collapsedContent !== undefined && collapsedContent !== null && <div className="tw-opacity-80 tw-transition-opacity tw-duration-200 hover:tw-opacity-100">{collapsedContent}</div>;
    $[26] = collapsedContent;
    $[27] = isExpanded;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="tw-flex tw-h-16 tw-w-full tw-items-center tw-justify-between tw-rounded-xl tw-border-0 tw-bg-transparent tw-px-5 tw-text-left tw-transition-colors tw-duration-200"><div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-4">{t13}{t14}</div></div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== children || $[33] !== contentId || $[34] !== isExpanded) {
    t16 = isExpanded && <m.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    }} id={contentId}>{children}</m.div>;
    $[32] = children;
    $[33] = contentId;
    $[34] = isExpanded;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <AnimatePresence>{t16}</AnimatePresence>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t17) {
    t18 = <LazyMotion features={domAnimation}><m.div className="tw-rounded-xl tw-bg-iron-900 tw-shadow-sm tw-ring-1 tw-ring-iron-700/50" initial={t2} animate={t3} transition={t4}>{t15}{t17}</m.div></LazyMotion>;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}